import React, { useEffect } from "react";
import CustomCheckbox from "./CustomCheckbox";
import { CHANGE_BO_TYPE, CHANGE_BO_TYPE_RENT, CLOSE_DEAL_END_OF_TRADING_DAY, CLOSE_DEAL_END_OF_TRADING_DAY_RENT} from "../../../../actions/create-bot-type";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import BooleanView from "../BooleanView";
import TutorialPopup from "../../../help/TutorialPopup";
import LeftRightForm from "./LeftRightForm";
import { isLockedDayTraderTemplate } from "../../../../utils/Utils";

const AutoClosePosEndOfTheDay = (props)=>{
    const {rent} = props
    const newBot = useSelector((state) => state.createBot.newBot);
    const rentBot = useSelector((state) => state.createBot.rentBot);
    console.log(rentBot)
    const {t} = useTranslation()
    const endDayDealClose = rent?rentBot.closeDealEndOfTradingDay:newBot.closeDealEndOfTradingDay;
    const isLockedTemplate = rent && isLockedDayTraderTemplate(rentBot);
    const dispatch = useDispatch()
     const setAutoCloseDealValue = (val) => {
        if (isLockedTemplate) {
          return;
        }
        dispatch({
          type: rent?CLOSE_DEAL_END_OF_TRADING_DAY_RENT:CLOSE_DEAL_END_OF_TRADING_DAY,
          payload: val?1:0
        });
      };

    useEffect(() => {
      if (isLockedTemplate && !parseInt(endDayDealClose)) {
        dispatch({
          type: CLOSE_DEAL_END_OF_TRADING_DAY_RENT,
          payload: 1,
        });
      }
    }, [dispatch, endDayDealClose, isLockedTemplate]);
     
    return(<>
       
                  
        <div style={{width:"100%"}}>
          <CustomCheckbox 
            val={isLockedTemplate ? 1 : endDayDealClose} 
            checked={isLockedTemplate ? true : !!endDayDealClose} 
            callback={setAutoCloseDealValue}
            label={t("auto-close-trading")}
            id={'auto-close-trading'}
            tutorial={<TutorialPopup content={t("auto-close-help")} />}
            disabled={isLockedTemplate}
            >
        </CustomCheckbox>
          </div>
    </>)
}

export default AutoClosePosEndOfTheDay;
